<script>
export default {
    name: 'schema.org',
    props: ['info'],
    render: function (createElement) {
        return createElement(
            'script',
            { attrs: { type: 'application/ld+json' } },
            this.schemaInfo && JSON.stringify(this.schemaInfo)
        );
    },
    computed: {
        schemaInfo() {
            if (!this.info) {
                return '';
            }
            if (Array.isArray(this.info)) {
                return this.info.map(obj =>
                    Object.assign({}, obj, { '@context': 'http://schema.org' })
                );
            }
            return Object.assign({}, this.info, {
                '@context': 'http://schema.org'
            });
        }
    }
};
</script>
